import { dsApiPath } from '../constants';

export const getComponentFilesURL = (id: string): string => {
  const baseLink = `${dsApiPath}/object-storage/components-files/${id}`;
  const downloadLink = `${baseLink}/download?fileContentData=true`;
  return `${downloadLink}&attachment=false`;
};
